import type { JSX } from 'react';
import { IDashboardWidgetCatalogItem } from '../../../types/IDashboardWidgetCatalogItem';
import { TopAssetTypesWidgetConfiguration } from './TopAssetTypesWidgetConfiguration';
import { DashboardWidgetType } from '@/modules/dashboards/types/DashboardWidgetType';
import { v4 } from 'uuid';
import { WidgetsRounded } from '@mui/icons-material';
import { TFunction } from 'i18next';
import { DashboardWidgetCatalogItemImageColorType } from '../../widget-catalog/DashboardWidgetCatalogItemImage';
import { LayoutItem } from 'react-grid-layout';

export class TopAssetTypesWidgetCatalogItem implements IDashboardWidgetCatalogItem<TopAssetTypesWidgetConfiguration> {
  title: string;
  description: string;
  icon: JSX.Element;
  iconColor: DashboardWidgetCatalogItemImageColorType;
  id: string;
  type: DashboardWidgetType;
  configuration: TopAssetTypesWidgetConfiguration;
  layout: LayoutItem;

  constructor(t: TFunction) {
    this.title = t('dashboard.topAssetTypesWidget.title');
    this.description = t('dashboard.topAssetTypesWidget.description');
    this.icon = <WidgetsRounded />;
    this.iconColor = 'yellow';
    this.id = v4();
    this.type = DashboardWidgetType.TopAssetTypesWidget;
    this.configuration = new TopAssetTypesWidgetConfiguration(t);
    this.layout = {
      h: 5,
      w: 3,
      i: v4(),
      x: 0,
      y: 0,
      maxH: 5,
      maxW: 4,
      minH: 3,
      minW: 2,
    };
  }
}
